import React from 'react'
import { cn } from '../../lib/utils.ts'
import { fieldVariants } from './fieldStyles.ts'

type DateFieldProps = {
  label?: string
  value: string
  onChange: (value: string) => void
  id?: string
  name?: string
  disabled?: boolean
  required?: boolean
  containerClassName?: string
  className?: string
}

export function DateField({
  label = 'Datum',
  value,
  onChange,
  id,
  name,
  disabled,
  required,
  className = '',
}: DateFieldProps) {
  return (
    <div className="relative mt-2">
      {label && <label className="block text-sm/6 font-medium text-gray-900 mb-1" htmlFor={id}>{label}</label>}
      <input
        type="date"
        id={id}
        name={name}
        disabled={disabled}
        required={required}
        className={cn(fieldVariants(), className)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}

export default DateField
